import { render, staticRenderFns } from "./RepayMstTable.vue?vue&type=template&id=ffabfd8e&"
import script from "./RepayMstTable.vue?vue&type=script&lang=js&"
export * from "./RepayMstTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports